<template>
    <div>
        <v-navigation-drawer
            v-model="drawer"
            :mini-variant.sync="mini"
            permanent
            app
            color="#fafafa"
        >
            <v-list-item class="px-2">
                <v-list-item-avatar>
                    <v-icon color="myGreen3">mdi-account</v-icon>
                </v-list-item-avatar>

                <v-list-item-title>KASIR</v-list-item-title>

                <v-btn icon @click.stop="mini = !mini">
                    <v-icon color="myGreen3">mdi-chevron-left</v-icon>
                </v-btn>
            </v-list-item>

            <v-divider></v-divider>

            <v-list dense>
                <v-list-item v-for="item in items" :key="item.title" link :to="item.to">
                    <v-list-item-icon>
                        <v-icon color="myGreen3">{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar app :color="bg">
            <v-container>
                <v-row>
                    <v-col class="pa-0" align-self="center">
                        <v-img :src="images" :width="$vuetify.breakpoint.xs ? 70 : 100"></v-img>
                    </v-col>
                    <v-col class="pa-0 text-right" align-self="center">
                        <v-btn class="myGreen3 white--text" @click="logout">LOGOUT</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-app-bar>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import Logo from "../../assets/PLABSID LOGO NEW BLACK.png";
export default {
    data: () => ({
        images: Logo,
        bg: "white",
        drawer: true,
        items: [
            { title: "Order Activity", icon: "mdi-account-group", to: "/" },
            { title: "Order History", icon: "mdi-camera-timer", to: "/history" },
            { title: "Cashier Notes", icon: "mdi-note-outline", to: "/notesList" },
        ],
        mini: true,
        loading: false,
        selection: 1,
    }),
    methods: {
        ...mapActions(["SET_LOGIN_MODAL"]),
        logout() {
            return this.SET_LOGIN_MODAL(true);
        },
        reserve() {
            this.loading = true;

            setTimeout(() => (this.loading = false), 2000);
        },
    },
};
</script>
